module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("The carriage … appeared more magnificent when seen than when described. Because of its wide fame it drew together many spectators; for from every city it came to, the people came out to meet it, and followed beside it when it went away, never wearied of their pleasure in the sight.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Diodorus, Book XVII, 28")])]), _vm._v(" "), _c('p', {
    staticClass: "center",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "img",
      "src": "Renault_TheNatureOfAlexander.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14f4d82f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-eipgraph.vue
// module id = 75
// module chunks = 0